import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';

interface AdminDashboardHeaderProps {
  totalOrdersCount: number;
  pendingQuotesCount: number;
  unreadContactsCount: number;
  totalRevenue: number;
  onLogout: () => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

const AdminDashboardHeader: React.FC<AdminDashboardHeaderProps> = ({
  totalOrdersCount,
  pendingQuotesCount,
  unreadContactsCount,
  totalRevenue,
  onLogout,
  onRefresh,
  isRefreshing,
}) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
        <div>
          <h2 className="fw-bold text-dark mb-1">Admin Dashboard</h2>
          <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
            Manage customer orders, reviews, and enquiries
          </p>
        </div>

        <div className="d-flex gap-2">
          <Button
            variant="outline-primary"
            onClick={onRefresh}
            disabled={isRefreshing}
            className="d-flex align-items-center gap-2 fw-semibold px-4 py-2"
            style={{ borderRadius: '8px' }}
          >
            <i className={`fas fa-sync-alt ${isRefreshing ? 'fa-spin' : ''}`}></i>
            {isRefreshing ? 'Refreshing...' : 'Refresh'}
          </Button>
          <Button
            variant="outline-danger"
            onClick={onLogout}
            className="d-flex align-items-center gap-2 fw-semibold px-4 py-2"
            style={{ borderRadius: '8px' }}
          >
            <i className="fas fa-sign-out-alt"></i> Logout
          </Button>
        </div>
      </div>

      <Row className="g-3 mb-5">
        <Col xs={12} sm={6} md={3}>
          <Card className="border-0 shadow-sm rounded-4 bg-white p-3 h-100">
            <div className="d-flex align-items-center gap-3">
              <div
                className="bg-light border text-primary rounded-3 p-3 d-flex align-items-center justify-content-center"
                style={{ width: '50px', height: '50px' }}
              >
                <i className="fas fa-shopping-bag" style={{ fontSize: '20px' }}></i>
              </div>
              <div>
                <span className="text-muted d-block" style={{ fontSize: '12px', fontWeight: 500 }}>
                  Total Orders
                </span>
                <h3 className="fw-bold text-dark mb-0">{totalOrdersCount}</h3>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <Card className="border-0 shadow-sm rounded-4 bg-white p-3 h-100">
            <div className="d-flex align-items-center gap-3">
              <div
                className="bg-light border text-warning rounded-3 p-3 d-flex align-items-center justify-content-center"
                style={{ width: '50px', height: '50px' }}
              >
                <i className="fas fa-file-invoice" style={{ fontSize: '20px' }}></i>
              </div>
              <div>
                <span className="text-muted d-block" style={{ fontSize: '12px', fontWeight: 500 }}>
                  Pending Quotes
                </span>
                <h3 className="fw-bold text-dark mb-0">{pendingQuotesCount}</h3>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <Card className="border-0 shadow-sm rounded-4 bg-white p-3 h-100">
            <div className="d-flex align-items-center gap-3">
              <div
                className="bg-light border text-info rounded-3 p-3 d-flex align-items-center justify-content-center"
                style={{ width: '50px', height: '50px' }}
              >
                <i className="far fa-envelope" style={{ fontSize: '20px' }}></i>
              </div>
              <div>
                <span className="text-muted d-block" style={{ fontSize: '12px', fontWeight: 500 }}>
                  Unread Enquiries
                </span>
                <h3 className="fw-bold text-dark mb-0">{unreadContactsCount}</h3>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={12} sm={6} md={3}>
          {/* <Card className="border-0 shadow-sm rounded-4 bg-white p-3 h-100">
            <div className="d-flex align-items-center gap-3">
              <div
                className="bg-light border text-success rounded-3 p-3 d-flex align-items-center justify-content-center"
                style={{ width: '50px', height: '50px' }}
              >
                <i className="fas fa-rupee-sign" style={{ fontSize: '20px' }}></i>
              </div>
              {/* <div>
                <span className="text-muted d-block" style={{ fontSize: '12px', fontWeight: 500 }}>
                  Est. Active Sales
                </span>
                <h3 className="fw-bold text-dark mb-0">₹{totalRevenue.toLocaleString('en-IN')}</h3>
              </div> 
            </div>
          </Card> */}
        </Col>
      </Row>
    </>
  );
};

export default AdminDashboardHeader;
